import { jsx as _jsx } from "react/jsx-runtime";
import { Image } from '@chakra-ui/react';
import { GatsbyImage, getSrc } from 'gatsby-plugin-image';
export const resolvePageMetadataImage = (metadata) => {
    const gatsbyImageData = metadata?.imageFile?.childImageSharp?.gatsbyImageData;
    const src = metadata?.image ||
        (gatsbyImageData ? getSrc(gatsbyImageData) : undefined) ||
        undefined;
    if (!gatsbyImageData && !src) {
        return undefined;
    }
    return {
        gatsbyImageData,
        src
    };
};
export const PageMetadataImage = ({ metadata, alt, className, style, imgClassName, imgStyle, objectFit, objectPosition, loading, sizes }) => {
    const resolved = resolvePageMetadataImage(metadata);
    if (!resolved) {
        return null;
    }
    if (resolved.gatsbyImageData) {
        return (_jsx(GatsbyImage, { image: resolved.gatsbyImageData, alt: alt, className: className, style: style, imgClassName: imgClassName, imgStyle: imgStyle, objectFit: objectFit, objectPosition: objectPosition, loading: loading, sizes: sizes }));
    }
    return (_jsx(Image, { src: resolved.src, alt: alt, className: className, style: { ...style, ...imgStyle }, objectFit: objectFit, objectPosition: objectPosition, loading: loading }));
};
